// external imports
import React, { Fragment } from 'react'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import styled, { css } from 'styled-components'
// helpers
import { up, addResponsivity } from '../lib/styles'
import { extractNodes, extractNodesFromData } from '../lib/helpers'
import injectIntl from '../lib/intl/injectIntl'

// components
import SEO from '../components/SEO'
import {
  Page,
  PageContent,
  Title,
  Gap,
  Row,
  Col,
  Link,
  Text,
  RH,
  Button,
  HeaderBar,
  PeopleList,
  Line,
  SubHeaderBar,
} from '../components'
import T from '../lib/intl/T'

import withExtraction from '../lib/withExtraction'
import { isCs, isSk } from '../lib/appVersions'
import { RichTextContent } from '../components/Card'

class Materials extends React.Component {
  componentDidMount() {}

  render() {
    const {
      location: { pathname },
      intl: { language, t },
    } = this.props

    return (
      <>
        <SEO title={t('Materiály k MIU')} pathname={pathname} />

        <HeaderBar>
          <HeaderBar.Content shrink={1}>
            <HeaderBar.Title>
              <T>Materiály k MIU</T>
            </HeaderBar.Title>
            <HeaderBar.SubTitle>
              <T>s čím pracují klienti a lektoři miu</T>
            </HeaderBar.SubTitle>
          </HeaderBar.Content>
        </HeaderBar>

        <Page grey>
          <PageContent style={{ minHeight: '292px' }}>
            <Gap gap="80px" mobileGap="48px" />
            <Col
              maxWidth="none"
              mobileMaxWidth="500px"
              margin="0 auto"
              width="100%"
            >
              <Title.Section>
                <T>Instrumenty MIU</T>
              </Title.Section>
            </Col>
            <Gap gap="40px" mobileGap="24px" />
            <SubHeaderBar.Content>
              <Col
                mobileMaxWidth="500px"
                maxWidth="50%"
                width="100%"
                margin="0 56px 0 0 "
              >
                <Text maxWidth="600px">
                  <RichTextContent>
                    {t('miu-materials - row 1 - col 1')}
                  </RichTextContent>
                </Text>
              </Col>

              <Gap gap="0" mobileGap="48px" />
              <Col mobileMaxWidth="500px" maxWidth="50%" width="100%">
                <Text>
                  <RichTextContent>
                    {t('miu-materials - row 1 - col 2')}
                  </RichTextContent>
                </Text>
              </Col>
            </SubHeaderBar.Content>
            <Gap gap="64px" mobileGap="40px" />
          </PageContent>
        </Page>
        <Page>
          <PageContent>
            <Gap gap="64px" mobileGap="40px" />
            <Row alignItems="center" responsive>
              <Col
                maxWidth="50%"
                width="100%"
                margin="0 56px 0 0"
                mobileMargin="0"
                maxWidth="570px"
                mobileMaxWidth="500px"
              >
                <Text mobileMaxWidth="500px" maxWidth="570px">
                  <RichTextContent>
                    {t('miu-materials - row 1 - cta')}
                  </RichTextContent>
                </Text>
              </Col>
              <Gap gap="0" mobileGap="32px" />

              <Col
                maxWidth="50%"
                mobileMaxWidth="none"
                width="100%"
                mobileWidth="auto"
              >
                <Button.SecondaryOrange
                  mobilePaddingLeft="10px"
                  mobilePaddingRight="12px"
                  iconLeft="trolley"
                  link={{
                    target: '_blank',
                    asA: true,
                    href:
                      'https://centrumrozum.cz/vzdelavaci-materialy/objednavka-miu/',
                  }}
                  responsiveFullWidth
                >
                  <T>instrumenty</T>
                </Button.SecondaryOrange>
              </Col>
            </Row>
            <Gap gap="64px" mobileGap="48px" />
          </PageContent>
        </Page>

        <Page grey>
          <PageContent style={{ minHeight: '292px' }}>
            <Gap gap="80px" mobileGap="48px" />
            <Col
              maxWidth="none"
              mobileMaxWidth="500px"
              margin="0 auto"
              width="100%"
            >
              <Title.Section>
                <T>Skripta k MIU</T>
              </Title.Section>
            </Col>
            <Gap gap="40px" mobileGap="24px" />
            <SubHeaderBar.Content>
              <Col
                mobileMaxWidth="500px"
                maxWidth="50%"
                width="100%"
                margin="0 56px 0 0 "
              >
                <Text maxWidth="600px">
                  <RichTextContent>
                    {t('miu-materials - row 2 - col 1')}
                  </RichTextContent>
                </Text>
              </Col>

              <Gap gap="0" mobileGap="48px" />
              <Col mobileMaxWidth="500px" maxWidth="50%" width="100%">
                <Text>
                  <RichTextContent>
                    {t('miu-materials - row 2 - col 2')}
                  </RichTextContent>
                </Text>
              </Col>
            </SubHeaderBar.Content>
            <Gap gap="64px" mobileGap="40px" />
          </PageContent>
        </Page>
        <Page>
          <PageContent>
            <Gap gap="64px" mobileGap="40px" />
            <Row alignItems="center" responsive>
              <Col
                maxWidth="50%"
                width="100%"
                margin="0 56px 0 0"
                mobileMargin="0"
                maxWidth="570px"
                mobileMaxWidth="500px"
              >
                <Text mobileMaxWidth="500px" maxWidth="570px">
                  <RichTextContent>
                    {t('miu-materials - row 2 - cta')}
                  </RichTextContent>
                </Text>
              </Col>
              <Gap gap="0" mobileGap="32px" />

              <Col
                maxWidth="50%"
                mobileMaxWidth="none"
                width="100%"
                mobileWidth="auto"
              >
                <Button.SecondaryOrange
                  mobilePaddingLeft="10px"
                  mobilePaddingRight="12px"
                  iconLeft="trolley"
                  link={{
                    target: '_blank',
                    asA: true,
                    href:
                      'https://forms.office.com/Pages/ResponsePage.aspx?id=Tkkf-fjnuEi5qXBBZqjf_SMZgNVGPMJGpu28MIVG8cxUN0gwN1FIVlpPWlRFWVlERlE0MUFETVhBUi4u',
                  }}
                  responsiveFullWidth
                >
                  <T>Skripta k MIU - button</T>
                </Button.SecondaryOrange>
              </Col>
            </Row>
            <Gap gap="64px" mobileGap="48px" />
          </PageContent>
        </Page>

        <Gap gap="80px" />
      </>
    )
  }
}

export default injectIntl(withExtraction(Materials))

// export const pageQuery = graphql`
//   query {
//     topImage: file(relativePath: { eq: "images/about-top.png" }) {
//       image: childImageSharp {
//         fluid(maxWidth: 660, quality: 100) {
//           ...GatsbyImageSharpFluid_withWebp
//         }
//       }
//     }
//     ks {
//       allPeople(sortBy: sortOrder_ASC) {
//         ...PersonFragment
//       }
//       allDocuments(sortBy: sortOrder_ASC) {
//         ...DocumentFragment
//       }
//     }
//   }
// `
